import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ConfigService, ConfirmationParticipantsModel, ParticipantModel } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-confirmation-participants',
    templateUrl: './confirmation-participants.component.html',
    styleUrls: ['./confirmation-participants.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationParticipantsComponent implements OnInit {
    @Input()
    public model: ConfirmationParticipantsModel;

    @Input()
    public parentForm: FormArray;

    public participantsForm: FormGroup;
    public participantsFormChildren: FormArray;
    public displayMobileNumber = false;
    public faTrash = faTrash;
    public isParticipantCreditTypeSelectorEnabled: boolean;

    public constructor(
        private readonly formBuilder: FormBuilder,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private configService: ConfigService,
    ) {}

    public ngOnInit(): void {
        this.displayMobileNumber = this.configService.getShowMobileNumberForParticipants();
        this.participantsFormChildren = this.formBuilder.array([]);
        this.participantsForm = this.formBuilder.group({
            children: this.participantsFormChildren,
        });

        Promise.resolve(undefined)
            .then(() => {
                this.parentForm.push(this.participantsForm);
            })
            .catch((error: Error) =>
                this.log.error('Error in ConfirmationParticipantsComponent -> ngOnInit -> parentForm.push: ', error),
            );

        this.isParticipantCreditTypeSelectorEnabled = this.configService.getParticipantCreditTypeSelectorEnabled();
    }

    public deleteParticipant(index: number): void {
        this.model.participantList.removeModel(index);
        this.changeDetectorRef.detectChanges();
    }

    public addParticipant(): void {
        const participant = new ParticipantModel(this.model.trainingName, this.model.productName);
        participant.setFieldValidity();
        this.model.participantList.addModel(participant);
        this.changeDetectorRef.detectChanges();
    }

    public participantSelectionChanged(participant: ParticipantModel): void {
        participant.onParticipantSelectionChanged();
        this.changeDetectorRef.detectChanges();
    }

    public participantCreditTypeChanged(): void {
        this.updateFormValidity();
        this.changeDetectorRef.markForCheck();
    }

    public updateFormValidity(shouldEmitEvent = false): void {
        this.parentForm.controls.forEach((control) => {
            control.updateValueAndValidity({ emitEvent: shouldEmitEvent });
        });
        this.changeDetectorRef.detectChanges();
    }
}
